import styled from "styled-components";

import { Row, Col, Container, Card, Button, Form } from "react-bootstrap";
import { Input, Upload } from "antd";

export const NftFormContainer = styled(Container)`
  font-family: "Roboto", sans-serif !important;
  margin-bottom: 40px;
`;

export const NftFormRow = styled(Row)``;
export const NftFormCol = styled(Col)``;

export const NftFormTitle = styled.h2`
  margin-top: 5rem;
  /* font-weight: 600; */

  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 32px;
  line-height: 24px;
  /* identical to box height, or 75% */

  /* Gray 1 */

  color: #333333;
`;
export const NftForms = styled(Form)``;
export const InputValue = styled(Input)``;

export const RequiredLabel = styled.label`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #333333;
  margin-top: 30px;
  font-family: "Roboto", sans-serif !important;

  & span {
    color: red;
    margin-right: 0.19rem;
  }
`;
export const SecondRequiredLabel = styled.label`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #333333;
  font-family: "Roboto", sans-serif !important;

  & span {
    color: red;
    margin-right: 0.19rem;
  }
`;
export const ErrorMessage = styled.p`
  text-align: start;
  color: red;
  margin-bottom: 0px;
  font-family: "Roboto", sans-serif !important;
`;
export const NameLabel = styled.label`
  font-size: 14px;
  color: white;
  font-family: "Roboto", sans-serif !important;

  & span {
    color: red;
  }
`;

export const NftUpload = styled(Upload)`
  .ant-upload.ant-upload-select-picture-card {
    width: 201px;
    height: 175px;
  }
`;
export const NftUploadLabel = styled.h5`
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 22px;
  font-family: "Roboto", sans-serif !important;
  /* identical to box height, or 92% */

  /* Gray 1 */

  color: #333333;
  margin-top: 20px;

  & span {
    color: red;
  }
`;
export const NftUploadInfo = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  /* identical to box height, or 157% */

  /* Gray 1 */

  color: #333333;
  margin-top: 10px;
  font-family: "Roboto", sans-serif !important;
`;

export const AddBtn = styled.button`
  margin-top: 3rem;
  padding: 0.5rem 1rem;

  background: #fafafa;
  /* Gray 3 */

  border: 1px solid #828282;
  border-radius: 5px;
`;

export const BottomBtn = styled.button`
  margin-top: 3rem;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5px 16px;
  background: #d35400;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.043);
  border-radius: 5px;
  border: none;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #ffffff;

  @media (max-width: 575.98px) {
    margin-left: auto;
    margin-right: auto;
  }
`;

export const PropertiesMain = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 2.5rem;
  font-size: 18px;
  line-height: 22px;
  font-family: "Roboto", sans-serif !important;
  color: #333333;
`;
export const PropertiesDetails = styled.div`
  font-weight: 500;

  & span {
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    /* identical to box height, or 110% */
    color: #4f4f4f;
  }
`;
